const SystemDialog = {
  name: 'systemDialog',
  state: { openSystemDialog: true, nameSystemDialog: '' },
  reducers: {
    openSystemDialog: (_, payload) => {
      return {
        openSystemDialog: payload.open,
        nameSystemDialog: payload.name,
      };
    },
    closeSystemDialog: (state, _) => {
      return {
        openSystemDialog: false,
        nameSystemDialog: '',
      };
    },
  },
};
export default SystemDialog;
